import { useEffect, useState } from 'react';
import {
  ExaminingTeamMembers,
  CardLimits,
} from '../SessionsParametersDialogContent/SessionsParametersDialogContent.types';
import { Modal } from '../../../../components/Modal/Modal.component';
import { Examiner, ITaskGroup } from '../../../../models/taskGroup.types';
import { getCardLimitsByExaminingTeamId } from '../../../../services/exams/examiningTeam/examiningTeam.service';
import { SessionsParametersCardLimitPerExaminer } from './SessionsParametersCardLimitPerExaminer.component';
import { useLayoutContext } from '../../../../Context/Layout.context';

interface SessionsParametersCardLimitPerExaminerDialogProps {
  selectedExaminer: Examiner;
  selectedTaskGroup: ITaskGroup;
  examiningTeamId: string;
  onClose: () => void;
  onOpen: boolean;
}

export const SessionsParametersCardLimitPerExaminerDialog: React.FC<
  SessionsParametersCardLimitPerExaminerDialogProps
> = ({ selectedExaminer, selectedTaskGroup, examiningTeamId, onClose, onOpen }) => {
  const [cardLimits, setCardLimits] = useState<ExaminingTeamMembers[]>([]);
  const [apiResponse, setApiResponse] = useState<ExaminingTeamMembers[]>([]);
  const [defaultCardLimit, setDefaultCardLimit] = useState<CardLimits>();
  const [reload, setReload] = useState<boolean>(false);

  const { showLoader } = useLayoutContext();

  const verifierId = selectedTaskGroup?.examTaskGroupCoordinators
    .flatMap((c) => c.examiningTeamChairmen)
    .find((ch) => ch.examiningTeam.examiningTeamId === examiningTeamId)
    ?.examiningTeam.examiningTeamMembers.find((m) => m.examiner.examinerPermission.some((p) => p.isVerifier))
    ?.examiner.examinerId;

  useEffect(() => {
    if (examiningTeamId || reload) {
      showLoader(true);
      getCardLimitsByExaminingTeamId(examiningTeamId)
        .then((response) => {
          const filtered = verifierId
            ? response.examiningTeamMembers.filter((m) => m.examinerId !== verifierId)
            : response.examiningTeamMembers;
          setCardLimits(filtered);
          setApiResponse(JSON.parse(JSON.stringify(filtered)));
          setDefaultCardLimit(response.defaultCardLimit);
        })
        .catch(() => {
          setCardLimits([]);
        })
        .finally(() => {
          showLoader(false);
        });
    }
  }, [examiningTeamId, reload, verifierId]);

  const handleReload = () => {
    setReload(true);
  };

  return (
    <Modal
      xCloseButton={onClose}
      id={'limitCardPerExaminer'}
      open={onOpen}
      size="md"
      title={`Indywidualne limity kart egzaminatorów w zespole: ${selectedTaskGroup?.name}- (PZE) ${selectedExaminer?.firstName} ${selectedExaminer?.lastName}`}
    >
      {cardLimits && defaultCardLimit && selectedTaskGroup && (
        <SessionsParametersCardLimitPerExaminer
          apiResponse={JSON.stringify(apiResponse)}
          items={cardLimits}
          onClose={onClose}
          reload={handleReload}
          defaultCardLimit={defaultCardLimit}
          selectedTaskGroupId={selectedTaskGroup.taskGroupId}
        />
      )}
    </Modal>
  );
};
